import React from 'react';
import { Box, Paper, List } from '@mui/material';

export interface FormNavProps {
  children?: React.ReactNode;
}

const VerticalTabs = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box>
      <Paper sx={{ borderRadius: 0 }}>
        <List sx={{ padding: 0, '& > li:last-child': { borderBottom: 'none' } }} role="tablist">
          {children}
        </List>
      </Paper>
    </Box>
  );
};

export default VerticalTabs;
